export type Message = {
  id?: number;
  type: string;
  text: string;
  overrides?: boolean;
  timeout?: number;
};

/**
 * Singleton class for displaying messages in a snackbar.
 *
 */
class MessageService {
  static DEFAULT_TIMEOUT = 5000;

  public messages: Message[] = [];
  public show: Boolean = false;
  public lastMessage: Message = { type: "", text: "" };
  private timeout: number = 0;

  private timeoutFn = () => {
    this.lastMessage.text = this.messages[0].text;
    this.lastMessage.type = this.messages[0].type;
    this.lastMessage.id = this.messages[0].id;
    this.lastMessage.timeout = this.messages[0].timeout;
    this.show = false;
    if (this.messages.length > 0) {
      this.messages.splice(0, 1);
      if (this.messages.length > 0) {
        this.show = true;
        this.timeout = window.setTimeout(
          this.timeoutFn,
          this.messages[0].timeout || MessageService.DEFAULT_TIMEOUT
        );
      }
    }
  };
  /**
   * Show the specified message in a snackbar, with the color scheme defined by param type.
   *
   * @param {string} type
   * @param {string} msg
   */
  public addMessage = (message: Message) => {
    if (message.id) {
      let clone = this.messages.find(item => {
        return item.id == message.id;
      });
      if (clone) return;
    }
    this.messages.push(message);
    this.show = true;
    if (this.messages.length == 1) {
      this.timeout = window.setTimeout(
        this.timeoutFn,
        message.timeout || MessageService.DEFAULT_TIMEOUT
      );
    } else if (message.overrides && this.messages.length > 1) {
      this.close();
    }
  };
  /**
   * Closes the active message
   */
  public close = () => {
    window.clearTimeout(this.timeout);
    this.timeoutFn();
  };
  /**
   * Clear all messages
   */
  public clear = () => {
    window.clearInterval(this.timeout);
    this.messages = [];
    this.show = false;
  };
  /**
   * Returns the active message
   */
  public message = () => {
    return this.messages[0];
  };
}

let messageService = new MessageService();

export default messageService;
